import React from 'react';
import AppLayout from './AppLayout';

const OnboardingLayout = ({ children }) => <AppLayout>{children}</AppLayout>

export default OnboardingLayout;
